import { render, staticRenderFns } from "./index-promo-new.vue?vue&type=template&id=032bbfb0"
import script from "./index-promo-new.vue?vue&type=script&lang=js"
export * from "./index-promo-new.vue?vue&type=script&lang=js"
import style0 from "./index-promo-new.vue?vue&type=style&index=0&id=032bbfb0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports